



























































import Vue from 'vue';
import BreadCrumbs from '@/components/bread-crumbs/BreadCrumbs.vue';
import { EventType, Phases } from '@/constants';
import { Appointment } from '@/types';
import { getAllAppointments, getPendingAppointments } from '@/api';
import { hideLoader, showLoader } from '@/util';
import { mapGetters } from 'vuex';
import { getSortFieldValues, searchAndHighlightText } from './services/service';
import { source } from '@/api/base';
import { bus } from '@/main';

export default Vue.extend({
  name: 'Appointments',
  components: {
    BreadCrumbs,
    AppointmentsList: () => import('./components/AppointmentsList.vue')
  },
  data () {
    return {
      stages: Phases,
      appointments: [] as Appointment[],
      pendingAppointments: [] as Appointment[],
      searchResults: [] as Appointment[],
      selectedStage: '',
      isOpenStageDropdown: false,
      searchText: '',
      placeholder: 'Search...',
      clearSearch: false,
      debounce: null as any,
      cancelSource: null as any,
      loading: false,
      params: {
        sort: {
          sortBy: 'Date',
          isAscending: true
        }
      } as any
    }
  },
  created () {
    bus.$on(EventType.APPOINTMENT_CANCELLED, (appointmentId: string) => {
      const deletedAppointment = this.appointments.findIndex((appt) => appt.appointmentId === appointmentId);
      const el = this.appointments.splice(deletedAppointment, 1);
    });
  },
  async mounted () {
    showLoader();
    this.loading = true;
    await Promise.all([this.fetchAppointments(), this.fetchPendingAppointments()]);
    this.loading = false;
    hideLoader();
  },
  computed: {
    ...mapGetters(['user', 'selectedJob', 'selectedJobDetails', 'signedIn']),
    getParams (): any {
      return {
        pageNumber: 0,
        pageSize: 10000,
        filterBy: {
          stage: this.selectedStage ? [this.selectedStage] : []
        },
        buyer: {
          jobNumber: this.selectedJob,
          email: [this.user.email]
        },
        searchText: this.searchText,
        ...this.params
      }
    },
    filteredAppointments (): Appointment[] {
      return this.selectedStage ? this.searchResults.filter((item) => item.appointmentType.stage.toLowerCase() === this.selectedStage.toLowerCase()) : this.searchResults;
    },
    sortedAppointments (): Appointment[] {
      let allAppointments = this.allAppointments;
      allAppointments = allAppointments.sort((appt1, appt2) => {
        const { fa, fb } = getSortFieldValues(appt1, appt2, this.getParams.sort.sortBy);
        return (fa > fb) ? 1 : (fb > fa) ? -1 : 0;
      });
      if (!this.getParams.sort.isAscending) {
        allAppointments.reverse();
      }
      if (this.getParams.sort.sortBy === 'Date') {
        const unscheduledAppts = allAppointments.filter((appt) => !appt.appointmentDate);
        const scheduledAppts = allAppointments.filter(appt => appt.appointmentDate);
        allAppointments = scheduledAppts.concat(unscheduledAppts);
      }
      return allAppointments;
    },
    allAppointments (): Appointment[] {
      return this.appointments.concat(this.filteredAppointments);
    }
  },
  watch: {
    async searchText (newValue, oldValue) {
      this.clearSearch = oldValue && !newValue;
      const el = this.$refs.input as HTMLElement;
      if (newValue.length >= 3) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.executeSearchOperation();
        }, 600);
      } else if (oldValue && !newValue) {
        clearTimeout(this.debounce);
        this.executeSearchOperation();
      }
    }
  },
  methods: {
    async selectPhase (value: string) {
      this.selectedStage = value;
      await this.refetchAppointmentData();
    },
    async fetchAppointments (params?: any) {
      this.params = params || this.params;
      if (this.cancelSource) {
        this.cancelSource.cancel(`Stop prev api and Start new search for ${this.searchText}`);
      }
      this.cancelSource = source;
      const response = await getAllAppointments(this.getParams);
      if (response) {
        this.appointments = response.appointments;
      }
      this.cancelSource = null;
    },
    async refetchAppointmentData (params?: any) {
      showLoader();
      this.loading = true;
      await this.fetchAppointments(params);
      this.loading = false;
      hideLoader();
    },
    async fetchPendingAppointments () {
      const response = await getPendingAppointments(this.selectedJob, this.selectedJobDetails.divisionId, this.user.email, 0);
      this.pendingAppointments = response.appointments;
      this.searchResults = response.appointments;
    },
    searchPendingAppointments () {
      if (this.clearSearch) {
        this.searchResults = this.pendingAppointments;
      } else {
        const searchResults = this.searchResults.length ? this.searchResults : this.pendingAppointments;
        const results = searchAndHighlightText(searchResults, this.searchText);
        this.searchResults = results;
      }
    },
    async executeSearchOperation () {
      const el = this.$refs.input as HTMLElement;
      el.blur();
      this.searchPendingAppointments();
      await this.refetchAppointmentData();
      el.focus();
    }
  }
});
